import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import Hotels from "./pages/Hotels";
import Templates from "./pages/Templates";
import TemplateBuilder from "./pages/TemplateBuilder";
import Audits from "./pages/Audits";
import AuditExecution from "./pages/AuditExecution";
import AuditReport from "./pages/AuditReport";
import Actions from "./pages/Actions";
import Users from "./pages/Users";
import Reports from "./pages/Reports";
import Calendar from "./pages/Calendar";
import AIInsights from "./pages/AIInsights";
import Digest from "./pages/Digest";
import HotelProgress from "./pages/HotelProgress";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FBFBF9]">
        <div className="w-8 h-8 border-2 border-[#14532D] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <AuthProvider>
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/" element={<Protected><Dashboard /></Protected>} />
          <Route path="/hotels" element={<Protected><Hotels /></Protected>} />
          <Route path="/templates" element={<Protected><Templates /></Protected>} />
          <Route path="/templates/:id/edit" element={<Protected><TemplateBuilder /></Protected>} />
          <Route path="/audits" element={<Protected><Audits /></Protected>} />
          <Route path="/calendar" element={<Protected><Calendar /></Protected>} />
          <Route path="/audits/:id/run" element={<Protected><AuditExecution /></Protected>} />
          <Route path="/audits/:id/report" element={<Protected><AuditReport /></Protected>} />
          <Route path="/actions" element={<Protected><Actions /></Protected>} />
          <Route path="/progress" element={<Protected><HotelProgress /></Protected>} />
          <Route path="/reports" element={<Protected><Reports /></Protected>} />
          <Route path="/digest" element={<Protected><Digest /></Protected>} />
          <Route path="/ai-insights" element={<Protected><AIInsights /></Protected>} />
          <Route path="/users" element={<Protected><Users /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
